import { createContext, useContext } from 'react';
import { translations } from './translations';
import { LANG_PREFIX } from './config';

const LanguageContext = createContext('en');

export const LanguageProvider = LanguageContext.Provider;

// Returns the value for `key` in the current language, falling back to English.
// Nested objects are reached with dot notation: t('nav.home')
const resolve = (dict, key) =>
  key.split('.').reduce((obj, part) => (obj ? obj[part] : undefined), dict);

export const useLanguage = () => {
  const lang = useContext(LanguageContext);

  const t = (key) =>
    resolve(translations[lang], key) ?? resolve(translations.en, key) ?? key;

  // Picks field or fieldEt off an object depending on language (used for
  // data arrays such as products.js, services lists etc.)
  const pick = (obj, field) =>
    lang === 'et' ? obj[`${field}Et`] ?? obj[field] : obj[field];

  // Prefixes a site-internal path with the active language prefix (/et, /da)
  const prefix = LANG_PREFIX[lang] || '';
  const path = (p) => (prefix ? `${prefix}${p === '/' ? '' : p}` : p);

  return { lang, t, pick, path };
};
